<!--
 * @Author: cryi.liu
 * @Date: 2020-07-13 09:42:52
 * @LastEditTime: 2020-07-16 18:15:18
 * @Description: 已选考试对象列表
-->
<template>
  <div class="selected-exam-obj">
    <p>所选考试对象：</p>
    <i-table :columns="columns" :data="examObjectList" border></i-table>
    <p class="scope-total">总计：{{ examObjectTotal }}人</p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';

export default {
  name: 'SelectedExamObject',
  data() {
    return {
      columns: [
        {
          title: '员工类型',
          key: 'staffType',
          align: 'center',
        },
        {
          title: '分公司',
          key: 'branch',
          align: 'center',
        },
        {
          title: '办事处',
          key: 'subBranch',
          align: 'center',
        },
        {
          title: '渠道',
          key: 'channel',
          align: 'center',
        },
        {
          title: '小渠道',
          key: 'compoChannel',
          align: 'center',
        },
        {
          title: '用户组',
          key: 'groupName',
          align: 'center',
        },
        {
          title: '身份类别',
          key: 'userType',
          align: 'center',
        },
        {
          title: '身份类别明细',
          key: 'userTypeDetail',
          align: 'center',
        },
        {
          title: '星级',
          key: 'starLevel',
          align: 'center',
        },
        {
          title: '主营产品',
          key: 'hrMainGroup',
          align: 'center',
        },
        {
          title: '人数',
          key: 'count',
          align: 'center',
        },
        {
          title: '删除',
          key: 'delete',
          align: 'center',
          render: (h, params) => h('div', [
            h('a', {
              on: {
                click: this.deleteExamObject(params.row),
              },
            }, '删除'),
          ]),
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      token: 'authStore/token',
      paperId: 'createPaperStore/paperId',
      pageType: 'createPaperStore/pageType',
      addExamObjectType: 'createPaperStore/addExamObjectType',
      examObjectList: 'createPaperStore/examObjectList',
      examObjectTotal: 'createPaperStore/examObjectTotal',
    }),
  },
  watch: {
    pageType: {
      immediate: true,
      handler(type) {
        if (type === 'edit') {
          this.columns = [
            {
              title: '分公司',
              key: 'branch',
              align: 'center',
            },
            {
              title: '办事处',
              key: 'subBranch',
              align: 'center',
            },
            {
              title: '渠道',
              key: 'channel',
              align: 'center',
            },
            {
              title: '小渠道',
              key: 'compoChannel',
              align: 'center',
            },
            {
              title: '身份类别',
              key: 'userType',
              align: 'center',
            },
            {
              title: '身份类别明细',
              key: 'userTypeDetail',
              align: 'center',
            },
            {
              title: '星级',
              key: 'starLevel',
              align: 'center',
            },
            {
              title: '主营产品',
              key: 'hrMainGroup',
              align: 'center',
            },
            {
              title: '人数',
              key: 'count',
              align: 'center',
            },
          ];
        }
      },
    },
  },
  methods: {
    ...mapActions({
      setExamObjectList: 'createPaperStore/invokeSetExamObjectList',
      setExamObjectTotal: 'createPaperStore/invokeSetExamObjectTotal',
      setCanAddExamObject: 'createPaperStore/invokeSetCanAddExamObject',
      setCanAddExamObjectForUploadExcel: 'createPaperStore/invokeSetCanAddExamObjectForUploadExcel',
    }),
    /**
     * 点击删除考试对象
     */
    deleteExamObject({ id }) {
      return () => {
        if (window.confirm('是否删除考试对象？')) {
          if (this.addExamObjectType === 'Scope') {
            this.requestDeleteExamObjectAndSetting(id);
          } else if (this.addExamObjectType === 'Excel') {
            this.requestDeleteExamObjectByExcelAndSetting();
          }
        }
      };
    },
    /**
     * 请求删除考试对象并设置
     */
    requestDeleteExamObjectAndSetting(scopeId) {
      this.requestDeleteExamObject(scopeId)
        .then(() => {
          this.requestGetExamObject()
            .then((result) => {
              this.setExamObjectTotal({ examObjectTotal: result.total });

              let { list } = result;
              if (!list) {
                list = [];
              }

              list.forEach((item) => {
                if (item.dispatched) {
                  item.staffType = '第三方员工';

                  if (!item.branch) {
                    item.branch = '所有分公司';
                  }

                  if (!item.subBranch) {
                    item.subBranch = '所有办事处';
                  }

                  if (!item.channel) {
                    item.channel = '所有渠道';
                  }

                  if (!item.compoChannel) {
                    item.compoChannel = '所有小渠道';
                  }

                  if (!item.userType) {
                    item.userType = '所有';
                  }

                  if (!item.userTypeDetail) {
                    item.userTypeDetail = '所有';
                  }

                  if (!item.starLevel) {
                    item.starLevel = '所有';
                  }

                  if (!item.mainGroup) {
                    item.hrMainGroup = '所有主营产品';
                  }

                  if (!item.groupName) {
                    item.groupName = '--';
                  }
                } else {
                  item.staffType = '非第三方员工';

                  if (!item.branch) {
                    item.branch = '所有分公司';
                  }

                  if (!item.subBranch) {
                    item.subBranch = '所有办事处';
                  }

                  if (!item.channel) {
                    item.channel = '所有渠道';
                  }

                  if (!item.compoChannel) {
                    item.compoChannel = '所有小渠道';
                  }

                  if (!item.userType) {
                    item.userType = '--';
                  }

                  if (!item.userTypeDetail) {
                    item.userTypeDetail = '--';
                  }

                  if (!item.starLevel) {
                    item.starLevel = '--';
                  }

                  if (!item.mainGroup) {
                    item.hrMainGroup = '--';
                  }

                  if (!item.groupName) {
                    item.groupName = '所有用户组';
                  }
                }
              });

              this.setExamObjectList({ examObjectList: list });

              if (list.length === 0) {
                this.setCanAddExamObject({ canAddExamObject: true });
              }
            })
            .catch((result) => {
              alert(result.msg);
            });
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求删除考试对象
     */
    requestDeleteExamObject(scopeId) {
      const params = {
        paperId: this.paperId,
        scopeId,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateDeleteExamObject(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求获取考试对象列表
     */
    requestGetExamObject() {
      return new Promise(async (resolve, reject) => {
        const result = await axios.get(`/examcentersite/paper/${this.paperId}/scope`, { headers: { psstoken: this.token } });

        if (result.data.code === '200') {
          resolve(result.data.data);
        } else {
          reject(result.data.data);
        }
      });
    },
    /**
     * 请求删除通过 Excel 上传的考试对象并设置
     */
    requestDeleteExamObjectByExcelAndSetting() {
      this.requestDeleteExamObjectByExcel()
        .then(() => {
          this.setExamObjectList({ examObjectList: [] });
          this.setExamObjectTotal({ examObjectTotal: 0 });

          this.setCanAddExamObject({ canAddExamObject: true });
          this.setCanAddExamObjectForUploadExcel({ canAddExamObjectForUploadExcel: true });
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求删除通过 Excel 上传的考试对象并设置
     */
    requestDeleteExamObjectByExcel() {
      const params = {
        paperId: this.paperId,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateDeleteExamObjectByExcel(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.selected-exam-obj {
  width: 100%;

  > p {
    margin-bottom: 12px;
  }

  > .scope-total {
    display: flex;
    justify-content: flex-end;
    font-weight: bold;
    font-size: 12px;
    padding: 4px;
  }
}
</style>
